// ----------------------------------------------------------------------

const ROOTS = {
  AUTH: '/auth',
  DAILY_OVERVIEW: '/daily-overview',
  BUSINESS_OVERVIEW: '/business-overview',
  INVENTORY_HEALTH: '/inventory-health',
  PURCHASEORDERS: '/purchase-orders',
  FULFILLMENTS: '/fulfillments',
  PRODUCTS: '/products',
  SUPPLIERS: '/suppliers',
  SUPPLIER_PERFORMANCE: '/supplier-performance',
  WAREHOUSES: '/warehouses',
  STOCKCHANGES: '/stock-changes',
  RULES: '/rules',
  UTILITIES: '/utilities',
  SHOPIFY: '/shopify',
  SETTINGS: '/settings',
  ONBOARDING: '/onboarding',
  RECOMMENDATIONS: '/recommendations',
  INSTALLATION: '/installation',
  SETUP: '/setup',
};

// ----------------------------------------------------------------------

export const paths = {
  // AUTH
  auth: {
    amplify: {
      login: `${ROOTS.AUTH}/amplify/login`,
      newPassword: `${ROOTS.AUTH}/amplify/new-password`,
      forgotPassword: `${ROOTS.AUTH}/amplify/forgot-password`,
      forceChangePassword: `${ROOTS.AUTH}/amplify/force-change-password`,
      companySelection: `${ROOTS.AUTH}/amplify/company-selection`,
    },
  },
  // ONBOARDING
  onboarding: {
    root: ROOTS.ONBOARDING,
    welcome: `${ROOTS.ONBOARDING}/welcome`,
    suppliers: `${ROOTS.ONBOARDING}/suppliers`,
    warehouses: `${ROOTS.ONBOARDING}/warehouses`,
    products: `${ROOTS.ONBOARDING}/products`,
    stockRecount: `${ROOTS.ONBOARDING}/stock-recount`,
    mappedSku: `${ROOTS.ONBOARDING}/mapped-sku`,
    settings: `${ROOTS.ONBOARDING}/settings`,
    billing: `${ROOTS.ONBOARDING}/billing`,
    complete: `${ROOTS.ONBOARDING}/complete`,
  },
  // DAILY OVERVIEW
  dailyOverview: {
    root: ROOTS.DAILY_OVERVIEW,
  },
  // BUSINESS OVERVIEW
  businessOverview: {
    root: ROOTS.BUSINESS_OVERVIEW,
  },
  // INVENTORY HEALTH
  inventoryHealth: {
    root: ROOTS.INVENTORY_HEALTH,
  },
  purchaseorders: {
    root: ROOTS.PURCHASEORDERS,
    new: `${ROOTS.PURCHASEORDERS}/new`,
    details: (id: string) => `${ROOTS.PURCHASEORDERS}/details/${id}`,
    edit: (id: string) => `${ROOTS.PURCHASEORDERS}/edit/${id}`,
  },
  fulfillments: {
    root: ROOTS.FULFILLMENTS,
  },
  products: {
    root: ROOTS.PRODUCTS,
    list: `${ROOTS.PRODUCTS}/list`,
    analytics: `${ROOTS.PRODUCTS}/analytics`,
    detail: (id: string) => `${ROOTS.PRODUCTS}/${id}`,
  },
  suppliers: {
    root: ROOTS.SUPPLIERS,
    list: `${ROOTS.SUPPLIERS}/list`,
    performance: `${ROOTS.SUPPLIERS}/performance`,
    performanceDetail: (id: string) => `${ROOTS.SUPPLIERS}/performance/${id}`,
    new: `${ROOTS.SUPPLIERS}/new`,
    edit: (id: string) => `${ROOTS.SUPPLIERS}/edit/${id}`,
  },
  // Legacy redirect - kept for backwards compatibility
  supplierPerformance: {
    root: ROOTS.SUPPLIER_PERFORMANCE,
  },
  warehouses: {
    root: ROOTS.WAREHOUSES,
  },
  stockChanges: {
    root: ROOTS.STOCKCHANGES,
    new: `${ROOTS.STOCKCHANGES}/new`,
    edit: (id: string) => `${ROOTS.STOCKCHANGES}/edit/${id}`,
  },
  rules: {
    root: ROOTS.RULES,
    orderRules: `${ROOTS.RULES}?tab=order-rules`,
    purchaseOrderRules: `${ROOTS.RULES}?tab=purchase-order-rules`,
    orderRulesNew: `${ROOTS.RULES}/order-rules/new`,
    purchaseOrderRulesNew: `${ROOTS.RULES}/purchase-order-rules/new`,
    orderRulesEdit: (id: string) => `${ROOTS.RULES}/order-rules/edit/${id}`,
    purchaseOrderRulesEdit: (id: string) => `${ROOTS.RULES}/purchase-order-rules/edit/${id}`,
  },
  utilities: {
    root: ROOTS.UTILITIES,
    new: `${ROOTS.UTILITIES}/new`,
    edit: (id: string) => `${ROOTS.UTILITIES}/edit/${id}`,
  },
  shopify: {
    auth: `${ROOTS.SHOPIFY}/auth`,
    callback: `${ROOTS.SHOPIFY}/callback`,
    reapproval: `${ROOTS.SHOPIFY}/reapproval`,
  },
  settings: {
    root: ROOTS.SETTINGS,
    billing: `${ROOTS.SETTINGS}/billing`,
    general: `${ROOTS.SETTINGS}/general?tab=general`,
    inventory: `${ROOTS.SETTINGS}/general?tab=inventory`,
    alerts: `${ROOTS.SETTINGS}/general?tab=alerts`,
    users: `${ROOTS.SETTINGS}/users`,
    multiStore: `${ROOTS.SETTINGS}/multi-store`,
  },
  // RECOMMENDATIONS
  recommendations: {
    root: ROOTS.RECOMMENDATIONS,
    details: (id: string) => `${ROOTS.RECOMMENDATIONS}/details/${id}`, // Added details path
  },
  // INSTALLATION
  installation: {
    integrationType: `${ROOTS.INSTALLATION}/integration-type`,
    companyRegistration: `${ROOTS.INSTALLATION}/company-registration`,
    multiStoreToken: `${ROOTS.INSTALLATION}/multi-store-token`,
  },
  // SETUP — the first-install status page, reached from the install banner
  setup: {
    root: ROOTS.SETUP,
  },
};
